import exportUtils from "@/hooks/exportUtils"
import axios from "@axios"

const { exportData } = exportUtils()

// Endpoints
let studentsEndpoint = '/students'
let restoreStudentEndpoint = '/students/restore'
let exportStudentsEndpoint = '/download-students'
// let destroyStudentEndpoint = '/students/hardDelete'

/**
 * ÍNDICE
 * 
 * {@link getStudents} - Obtener alumnos
 * {@link getStudents} - Obtener alumno
 * {@link addStudent} - Añadir alumnos
 * {@link getTrashedStudents} - Obtener alumnos eliminados
 * {@link restoreStudent} - Restaurar alumno
 * {@link destroyStudent} - Eliminar alumno (No habilitado)
 * {@link exportStudents} - Exportar alumnos
 */

/**
 * Obtener todos los alumnos
 * @param {*} data Datos para filtrar la consulta
 * @returns students | error
 */
export const getStudents = function(data) {
    try {
        return new Promise((resolve, reject) => {
            axios.get(studentsEndpoint, { params:  data  })
            .then(response => { return resolve(response.data) })
            .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}

/**
 * Obtener evaluación
 * @param {integer} id ID del estudiante 
 * @returns student
 */

export const getStudent = function ( id ) {
    try {
        return new Promise((resolve, reject) => {
            axios
                .get(`${studentsEndpoint}/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        })

    } catch (error) {
        return error
    }
}

/**
 * Añadir estudiante
 * @param {*} data Datos estudiante
 * @returns response | error
 */
export const addStudent = function(data) {
    try {
        return new Promise((resolve, reject) => {
            axios.post(studentsEndpoint, data )
            .then(response => { return resolve(response.data) })
            .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}

/**
 * Obtener los alumnos eliminados
 * @returns trashedStudents | error
 */
export const getTrashedStudents = function() {
    try {
        return new Promise((resolve, reject) => {
            axios.get(studentsEndpoint, { params: { trashed: true } })
            .then(response => {  return resolve(response.data.students) })
            .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}

/**
 * Restaurar un alumno borrado
 * @param {integer} id id del alumno
 * @returns boolean
 */
export const restoreStudent = function(id) {
    try {
        return new Promise((resolve, reject) => {
            axios.post(restoreStudentEndpoint, { id: id })
            .then(response => { return resolve(response.data) })
            .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}

/**
 * Eliminar de base de datos a un alumno
 * @param {integer} id id del alumno 
 * @returns boolean
 */
// export const destroyStudent = function(id) {
//     try {
//         return new Promise((resolve, reject) => {
//             axios.get(destroyStudentEndpoint, { id: id })
//             .then(response => { return resolve(true) })
//             .catch(error => { return reject(error) })
//         })
//     } catch (error) {
//         return error
//     }
// }

/**
 * Exportar listado de alumnos en diferentes formatos
 * @param {*} data Datos de búsqueda
 * @param {string} format [ 'PDF', 'XLS', 'CSV' ]
 */
export const exportStudents = function(data, format) {
    let fileName = `listado_alumnos_${new Date(Date.now()).toLocaleDateString('es-ES')}`
    if (format.toUpperCase() == "PDF" ) return exportData(exportStudentsEndpoint, data, fileName, format)
    if (format.toUpperCase() == "XLS" ) return exportData(exportStudentsEndpoint, data, fileName, format)
    if (format.toUpperCase() == "CSV" ) return exportData(exportStudentsEndpoint, data, fileName, format)
}